import { render, staticRenderFns } from "./newTimetable.vue?vue&type=template&id=968001d6&"
import script from "./newTimetable.vue?vue&type=script&lang=js&"
export * from "./newTimetable.vue?vue&type=script&lang=js&"
import style0 from "./newTimetable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports